import { Box, Button, Tooltip } from "@material-ui/core";
import { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Axios from "axios";
import { Loading } from "../../components/shared/loading";
import { UserContext } from "../../contexts/UserContext";
import { Helmet } from "react-helmet";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { useAdminStyles } from "../../components/admin/adminStyles";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { useToast } from "../../components/shared/Toast";

import AddIcon from "@material-ui/icons/Add";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";
const $ = require("jquery");

export const AllJobs = () => {
  const navigate = useNavigate();
  const classes = useAdminStyles();
  const toast = useToast();
  const { setUser } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    Axios.get("/api/admin/jobs", { headers: { headKey } }).then((res) => {
      if (res.status === 200 && res.data.status) {
        setData(res.data.data);
        setLoading(false);
        $(document).ready(function () {
          $("#jobs_table").DataTable({ destroy: true });
        });
      } else {
        setUser(null);
        navigate("/");
      }
    });
  };

  const toggleStatus = (id, current) => {
    const fd = new FormData();
    fd.append("id", id);
    Axios.post("/api/admin/job_status", fd, { headers: { headKey } }).then(
      (res) => {
        if (res.status === 200) {
          toast.success(current === "show" ? "Job hidden" : "Job shown");
          getData();
        } else {
          toast.error("Failed to update status");
        }
      }
    );
  };

  if (loading) return <Loading />;

  return (
    <div>
      <Helmet>
        <title>All Jobs - Admin | Arawinz Soft Solutions</title>
      </Helmet>

      <AdminPageHeader
        eyebrow="Manage"
        title="Jobs"
        subtitle="Post, edit, or show/hide job openings on the careers page."
        actions={
          <Button
            component={Link}
            to="/dash/addjob"
            className={classes.primaryBtn}
            startIcon={<AddIcon />}
          >
            Add Job
          </Button>
        }
      />

      <Box className={classes.tableWrap}>
        <table id="jobs_table" className="display" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Type</th>
              <th>Work</th>
              <th>Location</th>
              <th>Status</th>
              <th>Added</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map((da) => (
                <tr key={da.id}>
                  <td>{da.id}</td>
                  <td style={{ fontWeight: 600, color: "#1a1a1a" }}>
                    {da.title}
                  </td>
                  <td>{da.job_type}</td>
                  <td>{da.work_type}</td>
                  <td>{da.location}</td>
                  <td>
                    {da.status === "show" ? (
                      <span className={`${classes.badge} ${classes.badgeActive}`}>
                        <CheckCircleOutlineIcon /> Shown
                      </span>
                    ) : (
                      <span
                        className={`${classes.badge} ${classes.badgeInactive}`}
                      >
                        <RemoveCircleOutlineIcon /> Hidden
                      </span>
                    )}
                  </td>
                  <td>{da.created}</td>
                  <td>
                    <Box className={classes.actionCell}>
                      <Tooltip title="Edit" arrow>
                        <Link
                          to={"/dash/updatejob/" + da.id}
                          className={classes.iconBtn}
                          aria-label="Edit"
                        >
                          <EditOutlinedIcon />
                        </Link>
                      </Tooltip>
                      <Tooltip
                        title={da.status === "show" ? "Hide" : "Show"}
                        arrow
                      >
                        <button
                          type="button"
                          className={classes.iconBtn}
                          onClick={() => toggleStatus(da.id, da.status)}
                          aria-label={da.status === "show" ? "Hide" : "Show"}
                        >
                          {da.status === "show" ? (
                            <VisibilityOffOutlinedIcon />
                          ) : (
                            <VisibilityOutlinedIcon />
                          )}
                        </button>
                      </Tooltip>
                    </Box>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </div>
  );
};
